
export const CRYPTO_CURRENCYS = {
  USDTRC: 'USDTTRC20',
  USDTERC: 'USDTERC20',
  USDTBEP: 'USDTBEP20',
  BTC: 'BTC',
  ETH: 'ETH'
}

export const CRYPTO_CURRENCYS_USDT = {
  USDTRC: 'USDTTRC20',
  USDTERC: 'USDTERC20',
  USDTBEP: 'USDTBEP20'
}

export const CRYPTO_CURRENCYS_FORMATED = {
  USDTRC: 'USDT TRC20',
  USDTERC: 'USDT ERC20',
  USDTBEP: 'USDT BEP20'
}

export const GREY_ASSETS = ['USDTTRC20D', 'USDTERC20D', 'USDTBEP20D']

export const OBMENAT = {
  email: 'obmenat24@akseron.net'
}

export const AML = [
  'Risk score',
  'ATM',
  'Child exploitation',
  'Dark market',
  'Dark service',
  'Enforcement action',
  'Exchange fraudulent',
  'Exchange licensed',
  'Exchange unlicensed',
  'Gambling',
  'Illegal service',
  'Liquidity pools',
  'Marketplace',
  'Miner',
  'Mixer',
  'Other',
  'P2P exchange licensed',
  'P2P exchange unlicensed',
  'Payment',
  'Ransom',
  'Sanctions',
  'Scam',
  'Seized assets',
  'Stolen coins',
  'Terrorism financing',
  'Wallet'
]



// WEBPACK FOOTER //
// ./src/js/utils/consts.js